import { useTranslation } from 'react-i18next';
import { getNewTabLinkAttributes, type NewTabLinkAttributes } from './new-tab-a11y';

export type UseNewTabLinkPropsResult = {
    /** Safe to spread onto an `<a>` (target, rel, optional aria-label). */
    linkProps: NewTabLinkAttributes;
    openInNewTabLabel: string;
};

/**
 * Returns target/rel/(optional aria-label) for links that open in a new tab,
 * using the shared `common.openInNewTab` translation.
 */
export function useNewTabLinkProps(accessibleName?: string): UseNewTabLinkPropsResult {
    const { t } = useTranslation('common');
    const openInNewTabLabel = t('openInNewTab');
    const linkProps = getNewTabLinkAttributes(
        accessibleName
            ? {
                  accessibleName,
                  openInNewTabLabel,
              }
            : undefined
    );

    return {
        linkProps,
        openInNewTabLabel,
    };
}
